import React, { useContext, useEffect, useRef, useState } from 'react';
import { tokenContext } from '../TokenContext';
import { useHistory } from 'react-router-dom';
import { useServices } from '../../hooks/useServices';
import { Grid } from 'react-spinners-css';
import { Facebook } from 'react-spinners-css';

import '../pago/Pago.css';
import { PagoExitosoRec } from './PagoExitosoRec';
import { PagoCanceladoRec } from './PagoCanceladoRec';
import { ErrorPagoRec } from './ErrorPagoRec';
import { Helmet } from 'react-helmet';
import { useEventos } from '../../hooks/useEventos';

export const Recibo = () => {


    const {pay} = useContext(tokenContext);
    const respuestaJson = pay;
    console.log('LIC response: ',respuestaJson);
    const {guardaBitacora} = useServices();
    const pagina = useRef();

    const history = useHistory();

    const [loader, setLoader] = useState(false);
    const { regresaPagoRecargas } = useEventos();
   


    const checkString = (objetoValidar)=>{
        let respuestaJson2;
          if (typeof objetoValidar === 'string' || objetoValidar instanceof String)
          // it's a string
            respuestaJson2 = JSON.parse(objetoValidar);
          else{
            respuestaJson2 = objetoValidar;
          }
         
          return respuestaJson2
    }

    const cambiarError = (idError) =>{
      if(idError >= 4){
        return 4
      }else{
        return idError
      }
    }

    const mostrarRecibo = async()=>{
      if(respuestaJson){
          const respuestaJson2 =  await checkString(respuestaJson);
          console.log('respuestaJson2: ', respuestaJson2);
          if(respuestaJson2.paymentSelfServiceResponse){
              const requestBitacora = {
                "transactionExtId": respuestaJson2.paymentSelfServiceResponse.transactionExtId,
                "statusId": cambiarError(respuestaJson2.paymentSelfServiceResponse.statusId),
                "code": respuestaJson2.paymentSelfServiceResponse.message.code + "",
                "messageCode":respuestaJson2.paymentSelfServiceResponse.message.description,
                "authorizationCode":respuestaJson2.paymentSelfServiceResponse.authorizationCode,
                "approvalCode":respuestaJson2.paymentSelfServiceResponse.approvalCode,
                "approval_code":respuestaJson2.paymentSelfServiceResponse.approvalCode,
                "topupAmount": respuestaJson2.paymentSelfServiceResponse.chargeAmount,
                "topup_amount": respuestaJson2.paymentSelfServiceResponse.chargeAmount,
                "mdn": respuestaJson2.paymentSelfServiceResponse.dn,
                "transactionId":parseInt(respuestaJson2.paymentSelfServiceResponse.transactionExtId),
              }
             // console.log('request guardar bitacora: ', requestBitacora);
              regresaPagoRecargas(requestBitacora.messageCode);
              const response = await  guardaBitacora(requestBitacora);
              if (response) {
                  if(response.status){
                      setLoader(true);
                      //console.log('error en servicio update');
                      history.push("/");
                  }else{
                    if(respuestaJson2.paymentSelfServiceResponse.message.code != 1){
                      const error = {
                        code:respuestaJson2.paymentSelfServiceResponse.message.code,
                        description:respuestaJson2.paymentSelfServiceResponse.message.description
                      }
                    //  console.log('error de sistema: ', respuestaJson2.paymentSelfServiceResponse.message);
                      pagina.current = <ErrorPagoRec data1={response} errore={error}/>;
                      setLoader(true);
                      
                    }else{
                    //  console.log('response bitacora put:', response);
                      const detalle = respuestaJson2.paymentSelfServiceResponse.message.detail;
                      
                     // console.log('statusId: ',requestBitacora.statusId);
                      switch (requestBitacora.statusId) {
                            case 3:
                              //console.log('pago exitoso');
                              pagina.current = <PagoExitosoRec {...requestBitacora}/>;
                              break;
                            case 2:
                              //console.log('pago cancelado');
                              pagina.current = <PagoCanceladoRec {...requestBitacora}/>;
                              
                              break;
                            case 4:
                             // console.log('error pago');
                              pagina.current = <ErrorPagoRec {...requestBitacora}/>;
                           
                              break;
                            default:
                              pagina.current = <ErrorPagoRec {...requestBitacora}/>;
                             
                             // console.log('statusId desconocido o nulo');
                              break;
                      }
                      setLoader(true);
                    }
                  }
                
              } else{
                //console.log('error al update bitacora ', response)
                setLoader(true);
              }
            }else{
             // console.log('error de sistema de pago');
              history.push("/Error");
            }
      }else{
          history.push("/");
      }
  }

    

    useEffect(() => {
      mostrarRecibo();
    }, [pay])
    


  return (
    <>
    <Helmet>
        <title>Recargas Unefon</title>
      </Helmet>
    <div className="contenedorPromociones">
    { loader
        ? <>
            <div className="logoUnefon animate__animated animate__slideInLeft"></div>
            {pagina.current}

        </>  
        : <div className="spinner"><Facebook color="#594498"/></div>
    }
  </div>
  </>
  )
}
